import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { ref, get } from "firebase/database";
import { database } from "../firebaseConfig";

// Default configuration if none exists in Firebase.
const defaultHeadMetaConfig = {
    charset: "utf-8",
    icon: "https://www.marriottpharmaceutical.com/favicon.png",
    viewport: "width=device-width, initial-scale=1",
    themeColor: "#000000",
    description: "Web site created using create-react-app",
    appleTouchIcon: "https://www.marriottpharmaceutical.com/logo192.png",
    manifest: "https://www.marriottpharmaceutical.com/manifest.json",
    title: "React App"
};

const HeadMetaUpdater = () => {
    const [headMetaConfig, setHeadMetaConfig] = useState(defaultHeadMetaConfig);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchHeadMetaConfig = async () => {
            try {
                const snapshot = await get(ref(database, "headmeta"));
                if (snapshot.exists()) {
                    // Merge the fetched config with the default config.
                    setHeadMetaConfig({ ...defaultHeadMetaConfig, ...snapshot.val() });
                }
            } catch (error) {
                console.error("Error fetching head meta config:", error);
            }
            setLoading(false);
        };

        fetchHeadMetaConfig();
    }, []);

    if (loading) {
        return null; // or a loading spinner if desired.
    }

    return (
        <Helmet>
            <meta charSet={headMetaConfig.charset} />
            <link rel="icon" href={headMetaConfig.icon} />
            <meta name="viewport" content={headMetaConfig.viewport} />
            <meta name="theme-color" content={headMetaConfig.themeColor} />
            <meta name="description" content={headMetaConfig.description} />
            <link rel="apple-touch-icon" href={headMetaConfig.appleTouchIcon} />
            <link rel="manifest" href={headMetaConfig.manifest} />
            <title>{headMetaConfig.title}</title>
            {/* If you have additional custom meta fields, you can map over them here */}
        </Helmet>
    );
};

export default HeadMetaUpdater;
